import { render, staticRenderFns } from "./freeShipping.vue?vue&type=template&id=28af12e7&scoped=true"
var script = {}
import style0 from "./freeShipping.vue?vue&type=style&index=0&id=28af12e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af12e7",
  null
  
)

export default component.exports